import { TRANSLATION_SETTINGS_STORAGE_KEY } from "../constants";
import {
  createDefaultTranslationSettings,
  parseTranslationSettings,
  type TranslationSettings,
} from "./translationSettingsSchema";

export const TRANSLATION_SETTINGS_CHANGED_EVENT = "CBH_ADMIN_TRANSLATION_SETTINGS_CHANGED";

export function readTranslationSettings(): TranslationSettings {
  if (typeof window === "undefined") {
    return createDefaultTranslationSettings();
  }

  const rawValue = window.localStorage.getItem(TRANSLATION_SETTINGS_STORAGE_KEY);
  if (rawValue === null) {
    return createDefaultTranslationSettings();
  }

  try {
    return parseTranslationSettings(JSON.parse(rawValue));
  } catch {
    return createDefaultTranslationSettings();
  }
}

export function writeTranslationSettings(settings: TranslationSettings): void {
  if (typeof window === "undefined") {
    return;
  }

  const serializedSettings = JSON.stringify(settings);
  if (window.localStorage.getItem(TRANSLATION_SETTINGS_STORAGE_KEY) === serializedSettings) {
    return;
  }

  window.localStorage.setItem(TRANSLATION_SETTINGS_STORAGE_KEY, serializedSettings);
  window.dispatchEvent(
    new window.CustomEvent(TRANSLATION_SETTINGS_CHANGED_EVENT, { detail: settings })
  );
}

export function clearTranslationSettings(): void {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(TRANSLATION_SETTINGS_STORAGE_KEY);
  window.dispatchEvent(
    new window.CustomEvent(TRANSLATION_SETTINGS_CHANGED_EVENT, {
      detail: createDefaultTranslationSettings(),
    })
  );
}
